import StandardError from './Standard'

class MissingAccountError extends StandardError {
  constructor() {
    super("User doesn't have an account")
    this.status = 400
  }
}

export default MissingAccountError
